import { Check } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { Sort } from 'iconsax-react';
import type { FC } from 'react';

import {
  NOTIFICATION_SORT_LABELS,
  type NotificationSortOption,
  TAB_SORT_OPTIONS,
} from '@core/utils/notificationQueryParams';
import type { NotificationTab } from '@core/utils/notifications';

import { ButtonWithPopover } from '../ButtonWithPopover/ButtonWithPopover';
import { SlabCard } from '../SlabCard/SlabCard';

type Props = {
  tab: NotificationTab;
  value: NotificationSortOption;
  onChange: (value: NotificationSortOption) => void;
};

export const NotificationCenterSorting: FC<Props> = ({ tab, value, onChange }) => (
  <ButtonWithPopover
    sx={{ padding: '8px 10px' }}
    variant='slab-action-bordered'
    paperSx={{
      boxShadow: '0 5px 10px rgba(0,0,0,0.10)',
      marginY: 2,
    }}
    startIcon={<Sort variant='TwoTone' />}
  >
    <SlabCard paddingY={1} sx={{ width: '240px', marginY: 0 }}>
      {TAB_SORT_OPTIONS[tab].map((option) => {
        const isSelected = option === value;

        return (
          <Box
            key={option}
            onClick={() => onChange(option)}
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            padding={1.5}
            sx={{
              cursor: 'pointer',
              backgroundColor: isSelected ? 'SlabIndigo.50' : 'transparent',
            }}
          >
            <Typography variant='body1'>{NOTIFICATION_SORT_LABELS[option]}</Typography>
            {isSelected && <Check sx={{ fontSize: 18, color: 'SlabIndigo.500' }} />}
          </Box>
        );
      })}
    </SlabCard>
  </ButtonWithPopover>
);
